import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { FinSimulacao } from '../../../models/fin-simulacao';
import { CarregandoService } from '../../../services/carregando.service';
import { FinSimulacaoService } from '../../../services/fin-simulacao.service';
import { NotificacaoService } from '../../../services/notificacao.service';

@Component({
  selector: 'app-historico-fin-simulacao',
  templateUrl: './historico-fin-simulacao.component.html',
  styleUrls: ['./historico-fin-simulacao.component.scss']
})
export class HistoricoFinSimulacaoComponent implements OnInit {

  @Input() idTarefa: number;
  @Input() podeSelecionar: boolean;
  @Input() idSimulacaoSelecionada: number;
  @Output() selecionouSimulacao = new EventEmitter();

  simulacoesDoPedido: FinSimulacao[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(private carregandoService: CarregandoService, private finSimulacaoService: FinSimulacaoService,
    private notificacaoService: NotificacaoService
  ) { }

  ngOnInit() {
    this.buscarSimulacoesDoPedido();
  }

  buscarSimulacoesDoPedido() {
    this.carregandoService.mostra('buscarSimulacoesDoPedido');
    this.finSimulacaoService.buscarHistoricoPorTarefa(this.idTarefa).subscribe(dados => {
      this.simulacoesDoPedido = dados.result;
      this.carregandoService.esconde('buscarSimulacoesDoPedido');
    }, (erro) => {
      this.carregandoService.esconde('buscarSimulacoesDoPedido');
      this.notificacaoService.erro(erro);
    });
  }

  selecionarSimulacao(idSimulacao) {
    this.selecionouSimulacao.emit(idSimulacao);
  }
}
